module.exports = __webpack_public_path__ + "img/upload-file.c9d35868.svg";